import { CardType } from '@cencosud-cencommerce/paris-uikit';

import type { ISavedCardResponse } from '@/modules/perseo-billing/interfaces';

export const mapBrandToCardType = (brand: string): CardType => {
  const normalizedBrand = brand.toLowerCase();
  if (normalizedBrand?.includes('visa')) return CardType?.VISA;
  if (normalizedBrand?.includes('master')) return CardType?.MASTERCARD;
  if (normalizedBrand?.includes('cencosud')) return CardType?.CENCOSUD;

  return CardType.GENERIC;
};

export const findFavoriteAvailableCard = (cards: ISavedCardResponse[]) => {
  const favoriteValid = cards.find(
    (card) => card?.isFavorite && !card?.isExpired
  );
  if (favoriteValid) return favoriteValid;
  const firstValid = cards.find((card) => !card?.isExpired);
  if (firstValid) return firstValid;
  const favorite = cards.find((card) => card?.isFavorite);
  if (favorite) return favorite;

  return cards[0];
};
